// --- ResponsiveElements: slide-up and fade-in animation ---
import React, { useRef, useEffect, useState} from 'react';

interface ResponsiveElementsProps {
    children: React.ReactNode;
    isAnimateOnScroll: boolean;
    /**
     * Slide distance in px for the animation (default 100)
     */
    animationOffset?: number;
    /**
     * Optional className for layout control
     */
    className?: string;
}

export const ResponsiveElements: React.FC<ResponsiveElementsProps> = React.memo(({
    children,
    isAnimateOnScroll,
    animationOffset = 100,
    className = '',
}) => {
    const [visible, setVisible] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!isAnimateOnScroll) {
            // On large screens, animate on mount
            setVisible(true);
            return;
        }
        // On small screens, animate on scroll into view
        const handleScroll = () => {
            if (!ref.current) return;
            const rect = ref.current.getBoundingClientRect();
            if (rect.top < window.innerHeight - 60) {
                setVisible(true);
            }
        };
        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, [isAnimateOnScroll]);

    return (
        <div
            ref={ref}
            className={className}
            style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : `translateY(${animationOffset}px)`,
                transition: 'opacity 0.9s cubic-bezier(0.22, 1, 0.36, 1), transform 1.9s cubic-bezier(0.22, 1, 0.36, 1)',
            }}
        >
            {children}
        </div>
    );
});